export default "__VITE_ASSET__CQYC9Eq___"